import createIcon from '@/lib/create-icon'

const CricketIcon = createIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='18'
    viewBox='0 0 46 46'
    fill='none'
  >
    <path
      d='M13.4167 27.7406C13.4167 28.6233 13.4167 29.0647 13.5811 29.4614C13.7455 29.8584 14.0576 30.1704 14.6817 30.7945L15.2057 31.3185C15.8298 31.9427 16.1419 32.2548 16.5387 32.419C16.9356 32.5835 17.3769 32.5835 18.2596 32.5835H19.8951C21.2191 32.5835 21.8811 32.5835 22.4763 32.337C23.0716 32.0903 23.5396 31.6223 24.4759 30.686L39.3749 15.7871C40.7979 14.3641 41.5093 13.6527 41.838 12.859C42.2764 11.8007 42.2764 10.6117 41.838 9.5535C41.5093 8.7598 40.7979 8.04834 39.3749 6.6254C37.9518 5.20247 37.2403 4.491 36.4468 4.16224C35.3885 3.72392 34.1995 3.72392 33.1412 4.16224C32.3475 4.491 31.636 5.20247 30.2131 6.6254L15.3142 21.5243C14.378 22.4606 13.9099 22.9287 13.6633 23.524C13.4167 24.1191 13.4167 24.7811 13.4167 26.1052V27.7406Z'
      stroke='url(#paint0_linear_4795_3213)'
      strokeWidth='2.5'
      fill='none'
    />
    <path
      d='M13.4167 27.7406C13.4167 28.6233 13.4167 29.0647 13.5811 29.4614C13.7455 29.8584 14.0576 30.1704 14.6817 30.7945L15.2057 31.3185C15.8298 31.9427 16.1419 32.2548 16.5387 32.419C16.9356 32.5835 17.3769 32.5835 18.2596 32.5835H19.8951C21.2191 32.5835 21.8811 32.5835 22.4763 32.337C23.0716 32.0903 23.5396 31.6223 24.4759 30.686L39.3749 15.7871C40.7979 14.3641 41.5093 13.6527 41.838 12.859C42.2764 11.8007 42.2764 10.6117 41.838 9.5535C41.5093 8.7598 40.7979 8.04834 39.3749 6.6254C37.9518 5.20247 37.2403 4.491 36.4468 4.16224C35.3885 3.72392 34.1995 3.72392 33.1412 4.16224C32.3475 4.491 31.636 5.20247 30.2131 6.6254L15.3142 21.5243C14.378 22.4606 13.9099 22.9287 13.6633 23.524C13.4167 24.1191 13.4167 24.7811 13.4167 26.1052V27.7406Z'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.5'
      fill='none'
    />
    <path
      d='M13.4167 27.7406C13.4167 28.6233 13.4167 29.0647 13.5811 29.4614C13.7455 29.8584 14.0576 30.1704 14.6817 30.7945L15.2057 31.3185C15.8298 31.9427 16.1419 32.2548 16.5387 32.419C16.9356 32.5835 17.3769 32.5835 18.2596 32.5835H19.8951C21.2191 32.5835 21.8811 32.5835 22.4763 32.337C23.0716 32.0903 23.5396 31.6223 24.4759 30.686L39.3749 15.7871C40.7979 14.3641 41.5093 13.6527 41.838 12.859C42.2764 11.8007 42.2764 10.6117 41.838 9.5535C41.5093 8.7598 40.7979 8.04834 39.3749 6.6254C37.9518 5.20247 37.2403 4.491 36.4468 4.16224C35.3885 3.72392 34.1995 3.72392 33.1412 4.16224C32.3475 4.491 31.636 5.20247 30.2131 6.6254L15.3142 21.5243C14.378 22.4606 13.9099 22.9287 13.6633 23.524C13.4167 24.1191 13.4167 24.7811 13.4167 26.1052V27.7406Z'
      stroke='url(#paint1_radial_4795_3213)'
      strokeOpacity='0.6'
      strokeWidth='2.5'
      fill='none'
    />
    <path
      d='M13.2732 28.75L4.65687 37.3664C3.55871 38.4644 3.55871 40.2448 4.65687 41.3431C5.75502 42.4411 7.53547 42.4411 8.63363 41.3431L17.2499 32.7267'
      stroke='url(#paint2_linear_4795_3213)'
      strokeWidth='2.5'
      fill='none'
      strokeLinejoin='round'
    />
    <path
      d='M13.2732 28.75L4.65687 37.3664C3.55871 38.4644 3.55871 40.2448 4.65687 41.3431C5.75502 42.4411 7.53547 42.4411 8.63363 41.3431L17.2499 32.7267'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.5'
      fill='none'
      strokeLinejoin='round'
    />
    <path
      d='M13.2732 28.75L4.65687 37.3664C3.55871 38.4644 3.55871 40.2448 4.65687 41.3431C5.75502 42.4411 7.53547 42.4411 8.63363 41.3431L17.2499 32.7267'
      stroke='url(#paint3_radial_4795_3213)'
      strokeOpacity='0.6'
      strokeWidth='2.5'
      fill='none'
      strokeLinejoin='round'
    />
    <path
      d='M12.4584 38.3332L7.66675 33.5415'
      stroke='url(#paint4_linear_4795_3213)'
      strokeWidth='2.5'
      fill='none'
      strokeLinejoin='round'
    />
    <path
      d='M12.4584 38.3332L7.66675 33.5415'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.5'
      fill='none'
      strokeLinejoin='round'
    />
    <path
      d='M12.4584 38.3332L7.66675 33.5415'
      stroke='url(#paint5_radial_4795_3213)'
      strokeOpacity='0.6'
      strokeWidth='2.5'
      fill='none'
      strokeLinejoin='round'
    />
    <path
      d='M35.4583 40.2498C32.812 40.2498 30.6667 38.1045 30.6667 35.4582C30.6667 32.8118 32.812 30.6665 35.4583 30.6665C38.1047 30.6665 40.25 32.8118 40.25 35.4582C40.25 38.1045 38.1047 40.2498 35.4583 40.2498Z'
      stroke='url(#paint6_linear_4795_3213)'
      strokeWidth='2.5'
      fill='none'
      strokeLinejoin='round'
    />
    <path
      d='M35.4583 40.2498C32.812 40.2498 30.6667 38.1045 30.6667 35.4582C30.6667 32.8118 32.812 30.6665 35.4583 30.6665C38.1047 30.6665 40.25 32.8118 40.25 35.4582C40.25 38.1045 38.1047 40.2498 35.4583 40.2498Z'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.5'
      fill='none'
      strokeLinejoin='round'
    />
    <path
      d='M35.4583 40.2498C32.812 40.2498 30.6667 38.1045 30.6667 35.4582C30.6667 32.8118 32.812 30.6665 35.4583 30.6665C38.1047 30.6665 40.25 32.8118 40.25 35.4582C40.25 38.1045 38.1047 40.2498 35.4583 40.2498Z'
      stroke='url(#paint7_radial_4795_3213)'
      strokeOpacity='0.6'
      strokeWidth='2.5'
      fill='none'
      strokeLinejoin='round'
    />
    <defs>
      <linearGradient
        id='paint0_linear_4795_3213'
        x1='13.4167'
        y1='3.8335'
        x2='46.2825'
        y2='26.6569'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint1_radial_4795_3213'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(27.7918 32.5835) scale(14.375 14.6406)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint2_linear_4795_3213'
        x1='3.83325'
        y1='28.75'
        x2='19.1705'
        y2='39.4009'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint3_radial_4795_3213'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(10.5416 42.1666) scale(6.70834 6.83224)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint4_linear_4795_3213'
        x1='7.66675'
        y1='33.5415'
        x2='13.1444'
        y2='37.3454'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint5_radial_4795_3213'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(10.0626 38.3332) scale(2.39583 2.44009)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint6_linear_4795_3213'
        x1='40.25'
        y1='30.6665'
        x2='29.2948'
        y2='38.2743'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint7_radial_4795_3213'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(35.4583 40.2498) rotate(180) scale(4.79167 4.88019)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
    </defs>
  </svg>,
  'CricketIcon'
)

export default CricketIcon
